import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { StudioProvider, useStudio } from "./context/StudioContext";
import { PaletteProvider } from "./context/PaletteContext";
import { PlanDrawerProvider } from "./context/PlanDrawerContext";
import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import { OverridesProvider } from "./context/OverridesContext";
import { Toaster } from "./components/ui/sonner";
import OverridesRefresher from "./components/OverridesRefresher";
import ActivityTracker from "./components/ActivityTracker";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ServicePage from "./pages/ServicePage";
import SubServicePage from "./pages/SubServicePage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmedPage from "./pages/OrderConfirmedPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminOverviewPage from "./pages/AdminOverviewPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminConsultsPage from "./pages/AdminConsultsPage";
import AdminContentPage from "./pages/AdminContentPage";
import AdminActivityPage from "./pages/AdminActivityPage";

function Protected({ children }) {
  const { email } = useStudio();
  if (!email) return <Navigate to="/" replace />;
  return (
    <PlanDrawerProvider>
      <PaletteProvider>{children}</PaletteProvider>
    </PlanDrawerProvider>
  );
}

function AdminGate({ children }) {
  const { me, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-ink font-mono text-[11px] uppercase tracking-[0.28em] text-brand-mute">
        Checking session...
      </div>
    );
  }
  if (!me) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <StudioProvider>
        <OverridesProvider>
          <AdminAuthProvider>
            <BrowserRouter>
              <OverridesRefresher />
              <ActivityTracker />
              <Routes>
                <Route path="/" element={<Landing />} />

                <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                <Route path="/service/:serviceSlug" element={<Protected><ServicePage /></Protected>} />
                <Route path="/service/:serviceSlug/:subSlug" element={<Protected><SubServicePage /></Protected>} />
                <Route path="/checkout" element={<Protected><CheckoutPage /></Protected>} />
                <Route path="/order/:orderId" element={<Protected><OrderConfirmedPage /></Protected>} />

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminGate><AdminOverviewPage /></AdminGate>} />
                <Route path="/admin/orders" element={<AdminGate><AdminOrdersPage /></AdminGate>} />
                <Route path="/admin/consults" element={<AdminGate><AdminConsultsPage /></AdminGate>} />
                <Route path="/admin/activity" element={<AdminGate><AdminActivityPage /></AdminGate>} />
                <Route path="/admin/content" element={<AdminGate><AdminContentPage /></AdminGate>} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Toaster richColors position="bottom-right" theme="dark" />
            </BrowserRouter>
          </AdminAuthProvider>
        </OverridesProvider>
      </StudioProvider>
    </div>
  );
}

export default App;
